import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import initialState from '../redux/blogs/initialState';
import BlogCart from './BlogCart';
import BlogHeader from './BlogHeader';

const BlogPage = () => {
    const filters = useSelector(state => state.filters);
    const { type, titletxt, searchText } = filters;
    const [blogs, setBlogs] = useState([])

    useEffect(() => {
        setBlogs(initialState)
    }, [])


    // filter by catagory

    const filterByCatagory = (blogs) => {
        if (type !== 'all') {
            return blogs.catagory === type;
        }
        return blogs;
    }

    // filter by author 

    const filterByAuthor = (blogs) => {
        if (titletxt !== 'all') {
            return blogs.author === titletxt;
        }
        return blogs;
    }

    // filter by search

    const filterBySearch = (blogs) => {
        if (searchText === '') return blogs
        if(searchText){
            if (searchText === ' ') {
                return blogs
            }else{
                return blogs.title.toLowerCase().includes(searchText.toLowerCase())
            }
        }

    }
    console.log(searchText);
    return (
        <section
            class="relative bg-gray-50 pt-8 pb-20 px-4 sm:px-6 lg:pt-16 lg:pb-16 lg:px-8"
        >
            <div class="absolute inset-0">
                <div class="bg-white h-1/3 sm:h-2/3"></div>
            </div>
            <div class="relative max-w-7xl mx-auto">
                <BlogHeader />
                <div
                    class="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none"
                >
                    {
                        blogs
                            .filter(filterByCatagory)
                            .filter(filterByAuthor)
                            .filter(filterBySearch)
                            .map(dt => <BlogCart key={dt.id} dt={dt} />)
                    }
                </div>
            </div>
        </section>
    );
};

export default BlogPage;